import { SET_TOKENS, GET_TOKENS, CLEAR_TOKENS } from "./actionTypes";

const initialState = {
    list: {},
    loading: false,
    error: null
};

const coins = (state = initialState, action) => {
    switch (action.type) {
        case GET_TOKENS:
            return {
                ...state,
                loading: true,
                error: null,  // Reset error on new request
            };

        case SET_TOKENS:
            const tokens = action.payload?.tokens?.reduce((acc, v) => {
                const key = v?.symbol?.toLowerCase();
                acc[key] = v;
                return acc;
            }, {});
            return {
                ...state,
                list: tokens || {}, // Ensure no break if `tokens` is missing
                error: action.payload?.error || null,
                loading: false
            };

        case CLEAR_TOKENS:
            return {
                ...initialState  // Reset state to initial values
            };

        default:
            return state; // No mutation, just return the original state
    }
};

export default coins;
